import { TableCard } from '../../../../components'
import { SignAsoListHeader } from './components/header/SignAsoListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { SignAsoTable } from './table/SignAsoTable'

const SignAsoList = () => (
  <TableCard>
    <SignAsoListHeader />
    <SignAsoTable />
  </TableCard>
)

export const SignAsoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <SignAsoList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
